import { Modal } from 'antd'
import { buildCloseCreditRequestConfirmCopy } from 'src/utils/askForCreditBridgeHelpers'

/**
 * Chunk C5 / Chunk 3 — optional close of Ask-for-credit after CN apply (never silent).
 * Confirm closes all open credit asks on that PO.
 */
export function promptCloseCreditRequestAfterApply({
  onConfirm,
  onCancel,
  openCount = 1,
  purchaseOrderNumber = '',
} = {}) {
  const copy = buildCloseCreditRequestConfirmCopy({
    openCount,
    purchaseOrderNumber,
  })

  return new Promise(resolve => {
    Modal.confirm({
      title: copy.title,
      content: copy.body,
      okText: copy.okText,
      cancelText: copy.cancelText,
      centered: true,
      onOk: async () => {
        try {
          if (typeof onConfirm === 'function') {
            await onConfirm()
          }
          resolve({ closed: true })
        } catch (error) {
          resolve({ closed: false, error })
          throw error
        }
      },
      onCancel: () => {
        if (typeof onCancel === 'function') onCancel()
        resolve({ closed: false })
      },
    })
  })
}

export default promptCloseCreditRequestAfterApply
